module.exports = __webpack_public_path__ + "img/can.0a8459b3.svg";